// ANGULAR COMPONENTS

import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgReduxModule } from "@angular-redux/store";
import { NgRedux, DevToolsExtension } from "@angular-redux/store";
import { rootReducer, ArchitectUIState } from "./ThemeOptions/store";
import { ConfigActions } from "./ThemeOptions/store/config.actions";
import { AppRoutingModule } from "./app-routing.module";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";

import {
  CommonModule,
  LocationStrategy,
  HashLocationStrategy,
  registerLocaleData,
} from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";

import { CurrencyMaskModule } from "ng2-currency-mask";

import localePt from "@angular/common/locales/pt";
import { DigitOnlyModule } from "@uiowa/digit-only";

/* import * as moment from 'moment';
import 'moment/locale/pt-br'; */

// BOOTSTRAP COMPONENTS

import { AngularFontAwesomeModule } from "angular-font-awesome";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { LaddaModule } from "angular2-ladda";
import { ngxLoadingAnimationTypes, NgxLoadingModule } from "ngx-loading";
import { RoundProgressModule } from "angular-svg-round-progressbar";
import { SweetAlert2Module } from "@toverux/ngx-sweetalert2";
import { ToastrModule } from "ngx-toastr";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { CountUpModule } from "countup.js-angular2";
import { AgmCoreModule } from "@agm/core";
import { ImageCropperModule } from "ngx-image-cropper";
import {
  NgBootstrapFormValidationModule,
  CUSTOM_ERROR_MESSAGES,
} from "ng-bootstrap-form-validation";
import { AngularStickyThingsModule } from "@w11k/angular-sticky-things";
import { NouisliderModule } from "ng2-nouislider";
import { NgSelectModule } from "@ng-select/ng-select";
import { SelectDropDownModule } from "ngx-select-dropdown";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { JwBootstrapSwitchNg2Module } from "jw-bootstrap-switch-ng2";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { TextMaskModule } from "angular2-text-mask";
import { ClipboardModule } from "ngx-clipboard";
import { TextareaAutosizeModule } from "ngx-textarea-autosize";
import { ColorPickerModule } from "ngx-color-picker";
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { DROPZONE_CONFIG } from "ngx-dropzone-wrapper";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { ChartsModule } from "ng2-charts";
import { DatePipe } from "@angular/common";

import { CUSTOM_ERRORS } from "./configs/custom-erros";

// LAYOUTs

import { BaseLayoutComponent } from "./Layout/base-layout/base-layout.component";
import { AppsLayoutComponent } from "./Layout/apps-layout/apps-layout.component";
import { PagesLayoutComponent } from "./Layout/pages-layout/pages-layout.component";
import { ThemeOptions } from "./theme-options";

import { PageTitleComponent } from "./Layout/Components/page-title/page-title.component";

// HEADER

import { HeaderComponent } from "./Layout/Components/header/header.component";
import { DotsComponent } from "./Layout/Components/header/elements/dots/dots.component";
import { SearchBoxComponent } from "./Layout/Components/header/elements/search-box/search-box.component";
import { MegamenuComponent } from "./Layout/Components/header/elements/mega-menu/mega-menu.component";
import { MegapopoverComponent } from "./Layout/Components/header/elements/mega-menu/elements/megapopover/megapopover.component";
import { UserBoxComponent } from "./Layout/Components/header/elements/user-box/user-box.component";
import { DrawerComponent } from "./Layout/Components/header/elements/drawer/drawer.component";

// SIDEBAR

import { SidebarComponent } from "./Layout/Components/sidebar/sidebar.component";
import { LogoComponent } from "./Layout/Components/sidebar/elements/logo/logo.component";

// FOOTER

import { FooterComponent } from "./Layout/Components/footer/footer.component";
import { FooterDotsComponent } from "./Layout/Components/footer/elements/footer-dots/footer-dots.component";
import { FooterMenuComponent } from "./Layout/Components/footer/elements/footer-menu/footer-menu.component";

import { NgApexchartsModule } from "ng-apexcharts";

// Gauges Charts

import { GaugeModule } from "angular-gauge";
import { TrendModule } from "ngx-trend";
import { SolicitarSSComponent } from "./pages/ss/solicitar-ss/solicitar-ss.component";

// PAGES
import { HomeComponent } from "./pages/home/home.component";
import { LoginPageComponent } from "./pages/acesso/login-page/login-page.component";

// SERVICES
import { AccountService } from "./services/account.service";
import { AuthService } from "./services/auth.service";

// Pipes

import { SolicitarSSCadastrarComponent } from "./pages/ss/solicitar-ss/solicitar-ss-cadastrar.component";
import { SolicitarSSListaComponent } from "./pages/ss/solicitar-ss/solicitar-ss-lista.component";
import { UsuarioPageComponent } from "./pages/acesso/usuario-page/usuario-page.component";

// Demos
import { AvaliarSSComponent } from "./pages/ss/avaliar-ss/avaliar-ss.component";
import { AcompanharSSComponent } from "./pages/ss/acompanhar-ss/acompanhar-ss.component";

import { UsuarioService } from "src/app/services/usuario.service";

import { EmitirOSComponent } from "./pages/os/emitir-os/emitir-os.component";
import { ProgramarServicoComponent } from "./pages/programarServico/programar-servico.component";
import { ConsultarOsComponent } from "./pages/os/consultar-os/consultar-os.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";

import { FecharOsComponent } from "./pages/os/fechar-os/fechar-os.component";

import { EmitirOsAutomaticaComponent } from "./pages/os/emitir-os-automatica/emitir-os-automatica.component";

import { FuncionalidadesComponent } from "./pages/acesso/funcionalidades/funcionalidades.component";
import { ErrorsModule } from "./errors/errors.module";

import { UtilsModule } from "./utils/utils.module";
import { CadastrosModule } from "./pages/cadastros/cadastros.module";

import { UsuarioAlterarSenhaPageComponent } from "./pages/acesso/usuario-page/usuario-alterar-senha-page.component";
import { HistoricoEquipamentoComponent } from "./pages/historico-equipamento/historico-equipamento.component";
import { SatisfacaoServicoComponent } from "./pages/satisfacao-servico/satisfacao-servico.component";
import { GridOSsComponent } from "./components/grid-OSs/grid-OSs.component";
import { PesquisaEquipamentoComponent } from "./components/pesquisa-equipamento/pesquisa-equipamento.component";

import { EquipamentoComponent } from "./pages/equipamento/equipamento.component";
import { FooterBasicComponent } from "./components/footer-basic/footer-basic.component";
import { DetalhesEquipamentoComponent } from "./components/detalhes-equipamento/detalhes-equipamento.component";
import { DetalhesOSComponent } from "./components/detalhes-os/detalhes-os.component";

import { CadastrarPTComponent } from "./pages/pt/cadastro-pt/cadastrar-pt.component";
import { ListaPTComponent } from "./pages/pt/lista-pt/lista-pt.component";
import { SolicitarPtComponent } from "./pages/pt/solicitar-pt/solicitar-pt.component";
import { AcompanharPtComponent } from "./pages/pt/acompanhar-pt/acompanhar-pt.component";
import { QuantitativoServicosComponent } from "./pages/quantitativo-servicos/quantitativo-servicos.component";
import { EquipamentoRdComponent } from "./pages/relatorios-diarios-rd/equipamento-rd/equipamento-rd.component";
import { ModelosRdComponent } from "./pages/relatorios-diarios-rd/modelos-rd/modelos-rd.component";
import { EmissaoRdComponent } from "./pages/relatorios-diarios-rd/emissao-rd/emissao-rd.component";
import { CalendarioMensalComponent } from "./pages/os/calendario-mensal/calendario-mensal.component";
import { EntradaMaterialComponent } from "./pages/entrada-material/entrada-material.component";
import { ContainerMiddleComponent } from "./components/container-middle/container-middle.component";
import { FooterPageComponent } from "./components/footer-page/footer-page.component";
import { EntradasPeriodoComponent } from "./pages/entradas-periodo/entradas-periodo.component";
import { TratarOSAvaliadaComponent } from "./pages/tratar-osavaliada/tratar-osavaliada.component";
import { LogAvaliacaoComponent } from "./components/log-avaliacao/log-avaliacao/log-avaliacao.component";
import { VistoDeExecucaoComponent } from './pages/os/visto-de-execucao/visto-de-execucao.component';
import { ValidarOsComponent } from './pages/os/validar-os/validar-os.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  url: "https://httpbin.org/post",
  maxFilesize: 50,
  acceptedFiles: "image/*",
};

@NgModule({
  declarations: [
    // LAYOUT

    AppComponent,
    BaseLayoutComponent,
    AppsLayoutComponent,
    PagesLayoutComponent,
    PageTitleComponent,
    LoginPageComponent,

    // HEADER

    HeaderComponent,
    DotsComponent,
    SearchBoxComponent,
    MegamenuComponent,
    MegapopoverComponent,
    UserBoxComponent,
    DrawerComponent,

    // SIDEBAR

    SidebarComponent,
    LogoComponent,

    // FOOTER

    FooterComponent,
    FooterDotsComponent,
    FooterMenuComponent,

    // PAGES
    SolicitarSSComponent,
    HomeComponent,

    // Pipes

    SolicitarSSCadastrarComponent,
    SolicitarSSListaComponent,
    UsuarioPageComponent,
    UsuarioAlterarSenhaPageComponent,

    AvaliarSSComponent,
    AcompanharSSComponent,
    EmitirOSComponent,
    ProgramarServicoComponent,
    ConsultarOsComponent,
    DashboardComponent,
    FecharOsComponent,
    EmitirOsAutomaticaComponent,
    FuncionalidadesComponent,
    HistoricoEquipamentoComponent,
    GridOSsComponent,
    PesquisaEquipamentoComponent,
    EquipamentoComponent,
    FooterBasicComponent,
    DetalhesEquipamentoComponent,
    DetalhesOSComponent,

    // PT
    AcompanharPtComponent,
    CadastrarPTComponent,
    ListaPTComponent,
    SolicitarPtComponent,
    QuantitativoServicosComponent,
    EquipamentoRdComponent,
    ModelosRdComponent,
    EmissaoRdComponent,
    CalendarioMensalComponent,
    EntradaMaterialComponent,
    ContainerMiddleComponent,
    FooterPageComponent,
    EntradasPeriodoComponent,
    TratarOSAvaliadaComponent,
    SatisfacaoServicoComponent,
    LogAvaliacaoComponent,
    VistoDeExecucaoComponent,
    ValidarOsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgReduxModule,
    CommonModule,
    LoadingBarRouterModule,
    TextMaskModule,
    CurrencyMaskModule,
    DigitOnlyModule,

    // Angular Bootstrap Components

    PerfectScrollbarModule,
    NgbModule,
    AngularFontAwesomeModule,
    LaddaModule,
    FormsModule,
    ReactiveFormsModule,
    NgBootstrapFormValidationModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBorderRadius: "3px",
      primaryColour: "#3f6ad8",
    }),
    RoundProgressModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: "modal-content",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn",
    }),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      timeOut: 4000,
      enableHtml: true,
      preventDuplicates: true,
    }),
    SlickCarouselModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    CountUpModule,
    AgmCoreModule.forRoot({
      // please get your own API key here:
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
      apiKey: "",
    }),
    ImageCropperModule,
    AngularStickyThingsModule,
    NouisliderModule,
    NgSelectModule,
    SelectDropDownModule,
    NgMultiSelectDropDownModule.forRoot(),
    JwBootstrapSwitchNg2Module,
    AngularEditorModule,
    HttpClientModule,
    TextMaskModule,
    ClipboardModule,
    TextareaAutosizeModule,
    ColorPickerModule,
    DropzoneModule,

    // Charts

    ChartsModule,
    NgApexchartsModule,
    GaugeModule.forRoot(),
    TrendModule,
    ErrorsModule,
    UtilsModule,
    CadastrosModule,
  ],

  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    { provide: LOCALE_ID, useValue: "pt-br" },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      // DROPZONE_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
      // DEFAULT_DROPZONE_CONFIG,
    },
    {
      provide: CUSTOM_ERROR_MESSAGES,
      useValue: CUSTOM_ERRORS,
      multi: true,
    },
    ConfigActions,
    ThemeOptions,
    AuthService,
    AccountService,
    UsuarioService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    private ngRedux: NgRedux<ArchitectUIState>,
    private devTool: DevToolsExtension,
  ) {
    this.ngRedux.configureStore(
      rootReducer,
      {} as ArchitectUIState,
      [],
      [this.devTool.isEnabled() ? this.devTool.enhancer() : (f) => f],
    );

    // ToastrModule.forRoot({ positionClass: 'toast-top-center', progressBar: true, progressAnimation: 'decreasing' }),
  }
}

registerLocaleData(localePt);
